<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorEsgPresentations.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorEsgPresentations.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorEsgPresentations.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorEsgPresentations.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorEsgPresentations.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorEsgPresentations.canonical.pl'),
    },
  ],
}))

</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.esgPresentations.hero.title')"
      :lead="$t('investor.esgPresentations.hero.lead')"
      image="/images/investor/hero/esg-presentations.png"
    />

    <UiSection
      :id="$t('investor.esgPresentations.sectionId')"
      class="esg-presentations__section"
      color="white"
    >
      <FileList
        request-id="investor-esg-prezentacje-dokumenty"
        :show-title="true"
        variant="list"
        :file-item-link-options="{label:t('investor.files.seeFile')}"
      />
      
    </UiSection>
  </div>
</template>
